
import Msg from 'vux/src/components/msg/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
msg: Msg,
Divider,
XButton
},
props: ["dataConfig"],
data() {
return {
Title: "操作成功",
Desc:
"内容详情，可根据实际需要安排，如果换行则不超过规定长度，居中展现<a href='javascript:void(0);'>文字链接</a>",
Icon: "",

ButtonList: [










],

btnClose: {
type: "default",
text: "关闭",
onClick: () => {
this.closeWxWindow();
}
},

orderOpenId: "",
orderItem: {}
};
},
created() {

if (this.dataConfig && this.dataConfig.IsShowClose) {
if (this.dataConfig.ButtonList) {
this.dataConfig.ButtonList.push(this.btnClose);
}
}
},

methods: {


setTitle(title = '操作成功'){

this.dataConfig.Title = title;
},

setDesc(desc = ''){
this.dataConfig.Desc = desc;
},

addButton(text,type='primary',onClick){

var button = {
type: type,
text: text,
onClick: ()=>{
onClick(button);
}
};
this.dataConfig.ButtonList.push(button);
},


closeWxWindow() {
try {
WeixinJSBridge.call("closeWindow");
} catch (e) {
console.log(e);
}
},

changeIcon() {
if (!this.icon || this.icon === "success") {
this.icon = "warn";
return;
}
if (this.icon === "warn") {
this.icon = "info";
return;
}
if (this.icon === "info") {
this.icon = "waiting";
return;
}
if (this.icon === "waiting") {
this.icon = "success";
}
},

}
};
